var ChannelKeeper = /** @class */ (function () {
    function ChannelKeeper(socket) {
        this.socket = socket;
        this.channels = {};
    }
    ChannelKeeper.prototype.retrieveChannel = function (channelName, params) {
        if (this.channels[channelName]) {
            return this.channels[channelName];
        }
        else {
            var newChannel = this.socket.channel(channelName, params);
            this.channels[channelName] = newChannel;
            newChannel.join();
            return newChannel;
        }
    };
    return ChannelKeeper;
}());
export default ChannelKeeper;
//# sourceMappingURL=channelKeeper.js.map